export default __webpack_public_path__ + "static/IBMPlexSans-ExtraLightItalic-Latin1-fb701534860736366a46d416d9b6f57b.woff";